import { IRoute } from "shared/interface/types";
import { serviceFacilityRoutes } from "./serviceFacilityRoute";
import { groupRoutes } from "./groupRoute";
import { coverageRoutes } from "./coverageRoute";
import { serviceRoutes } from "./serviceRoute";
import { exclusionRoutes } from "./exclusionRoute";
import { makeRoutes } from "./auto/makeRoute";
import { modelRoutes } from "./auto/modelRoute";
import { planTypeRoutes } from "./auto/planTypeRoute";
import { regionRoutes } from "./regionRoute";
import { assemblyRoutes } from "./auto/assemblyRoute";
import { variantRoutes } from "./auto/variantRoute";

export const listManagementRoutes: IRoute[] = [
  ...serviceFacilityRoutes,
  ...groupRoutes,
  ...coverageRoutes,
  ...serviceRoutes,
  ...exclusionRoutes,
  ...makeRoutes,
  ...modelRoutes,
  ...planTypeRoutes,
  ...regionRoutes,
  ...assemblyRoutes,
  ...variantRoutes
];
